export const InteractiveCourseware = {
    "有疑问":"有疑問",
    "有提问":"有提問",
    "学习开始时间":"學習開始時間",
    "学习已开始":"學習已開始",
    "是否结束发布":"是否結束發布",
    "结束发布后学生将无法进入本课件学习":"結束發布後,學生將無法進入本課件學習",
    "学习页面":"學習頁面",
    "疑问数":"疑問數",
    "评论数":"評論數",
    "学习时间":"學習時間",
    "更换":"更換",
    "课件标题":"課件標題",
    "活动类型标签":"活動類型標簽",
    "课件内容":"課件內容",
    "增加内容分段":"增加內容分段",
    "允许作答试题":"允許作答試題",
    "允许下载":"允許下載",
    "不允许下载":"不允許下載",
    "总分":"總分",
    "截止时间":"截止時間",
    "请选择章节目录":"請選擇章節目錄",
    "系统检测到您的当前设备暂不支持全屏模式":"系統檢測到您的當前設備暫不支持全屏模式",
    "没有下一页了":"沒有下壹頁了",
    "当前是第一页":"當前是第壹頁",
    "页的讨论":"頁的討論",
    "是否删除该评论":"是否刪除該評論？",
    "批阅互动答题":"批閱互動答題",
    "试题分析":"試題分析",
    "互动批阅":"互動批閱",
    "您共学习了":"您共學習了",
    "页这是最后一页是否标记为已完成学习":"頁，這是最後壹頁，是否標記為“已完成學習”？",
    "此课件为空点击返回":"此課件為空，點擊返回",
    "老师已收到疑问":"老師已收到疑問",
    "有疑问学生":"有疑問學生",
    "课件学习":"課件學習",
    "学习统计":"學習統計",

}